import React, { Component, Fragment } from "react";
import { Card, Icon, Tag, Radio, Slider, Checkbox, Row, Col } from "antd";
import F from "../../../Functions";
import WizardFooter from "./wizard-footer";
import Jewelry from "./images/new/jewelry.svg";
import Antiques from "./images/new/antique.svg";
import Electronics from "./images/new/electronics.svg";
import MusicalInstruments from "./images/new/music-instruments.svg";
import Collectibles from "./images/new/collectibles.svg";
import FineArts from "./images/new/finearts.svg";
import SportsEquipment from "./images/new/sportsequip.svg";
import Firearms from "./images/new/firearm.svg";
import { Translate } from "react-translated";
import WizardPager from "../../../components/wizard-pager";
import SliderLayout from "./sliderlayout";

const RadioGroup = Radio.Group;

class Step extends Component {
  render() {
    const { wizard, updateField, handleBlur, updateRadioBtnToggle } = this.props;

    let rangeValues = [
      "",
      "$1-$10,000",
      "$10,001-$25,000",
      "$25,001-$50,000",
      "$50,001-$100,000",
      "$100,001-$150,000",
      "$150,001-$200,000",
      "$200,001-$250,000",
      "$250,001-$300,000",
      "$300,001-$350,000",
      "$350,001-$400,000",
      "$400,001-$450,000",
      "$450,001-$500,000",
      "$500,001-$600,000",
      "$600,001-$700,000",
      "$700,001-$800,000",
      "$800,001-$900,000",
      "$900,001-$1,000,000"
    ];
    let v1, v2;
    for (let i = 1; i < 21; i++) {
      v2 = 1000000 + 100000 * i;
      v1 = v2 - 100000 + 1;
      rangeValues.push(F.dollar_format(v1) + "-" + F.dollar_format(v2));
    }
    rangeValues.push("$3,000,001-$4,000,000");
    rangeValues.push("$4,000,001-$5,000,000");

    // let step = 500000;
    //   for (let i = 1; i <= 18; i++) {
    //     v2 = 1000000 + step * i;
    //     v1 = v2 - step + 1;
    //     rangeValues.push(F.dollar_format(v1) + "-" + F.dollar_format(v2));
    //   }

    let marks = {};
    for (let i = 0, rangeLen = rangeValues.length; i < rangeLen; i++) {
      marks[parseInt((i / (rangeLen - 1)) * 100, 10)] = {
        label:
          i === rangeValues.length - 1 ? rangeValues[i] : i === 0 ? "$0" : "",
        val: rangeValues[i]
      };
    }

    let personal_property_value = 0;
    if (wizard.personal_property_value !== "") {
      for (let x in marks) {
        if (marks[x].val === wizard.personal_property_value) {
          personal_property_value = parseInt(x, 10);
        }
      }
    }

    let personal_property_type = [];
    if (wizard.personal_property_type !== "") {
      personal_property_type = JSON.parse(wizard.personal_property_type);
    }

    const personal_property_types = [
      { name: "Jewelry", icon: Jewelry },
      { name: "Electronics", icon: Electronics },
      { name: "Musical instruments", icon: MusicalInstruments },
      { name: "Antiques", icon: Antiques },
      { name: "Fine arts", icon: FineArts },
      { name: "Sports Equipment", icon: SportsEquipment },
      { name: "Firearms", icon: Firearms },
      { name: "Collectibles", icon: Collectibles }
    ];

    // const personal_property_types = [
    //   { name: "Jewelry", icon: Jewelry },
    //   { name: "Furs", icon: Furs },
    //   { name: "Cameras", icon: Cameras },
    //   { name: "Musical instruments", icon: MusicalInstruments },
    //   { name: "Silverware", icon: Silverware },
    //   { name: "Fine arts", icon: FineArts },
    //   { name: "Golfer's equipment", icon: GolferEquipment },
    //   { name: "Sports equipment", icon: SportsEquipment },
    //   { name: "Firearms", icon: Firearms },
    //   { name: "Stamp collections", icon: StampCollections },
    //   { name: "Coin collections", icon: CoinCollections }
    // ];

    return (
      <Fragment>
        <div className="stepBody">
          <Card
            className="insidecard stepcard"
          >
            <div>
              <h5 className="headingText">
                “Other than customary items found in a home, do you have any special personal property of significant value of which we should be made aware ?”
              </h5>
            </div>
            <RadioGroup className="radiogroup"
              value={wizard.personal_property_toggle}
              onChange={(e) => {
                updateField("personal_property_toggle", e.target.value);
                if (!this.props.isExternalBFile) {
                  updateRadioBtnToggle();
                }
              }
              }

            >
              <Radio value={1} >
                <Translate text={`Yes`} />
              </Radio>
              <Radio value={0} >
                <Translate text={`No`} />
              </Radio>
            </RadioGroup>

            {wizard.personal_property_toggle === 1 ? (
              <div style={{ marginTop: 20 }}>
                <h5 className="titleText2 headingText">
                  Please Select Checklist : <span className='asteriskIcon'>*</span>
                </h5>
                <Checkbox.Group
                  className=""
                  value={personal_property_type}
                  style={{ width: "100%" }}
                  onChange={(checkedList) => {
                    updateField(
                      "personal_property_type",
                      JSON.stringify(checkedList)
                    );
                    if (!this.props.isExternalBFile) {
                      updateRadioBtnToggle();
                    }
                  }
                  }

                >
                  <Row gutter={[16, 16]} style={{ display: 'flex', flexWrap: 'wrap' }}>
                    {personal_property_types.map((item, i) => {
                      return (
                        <Col key={i}
                          xs={24}
                          sm={12}
                          md={8}
                          lg={6} className="checkbox_layout">
                          <Checkbox value={item.name} style={{ width: "100%" }}>
                            <div className="checkbox_items"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                              }}
                            >
                              <div className="icon"
                                style={{ flexShrink: 0 }}
                              >
                                <img src={item.icon} alt={item.name}
                                  style={{
                                    objectFit: "contain",
                                  }}
                                />
                              </div>
                              <div className="title" style={{ flexGrow: 1 }}>
                                <Translate text={item.name} />
                              </div>
                            </div>
                          </Checkbox>
                        </Col>
                      );
                    })}
                  </Row>
                </Checkbox.Group>

                {wizard.personal_property_type && wizard.personal_property_type.length > 2 && (<div style={{ marginTop: 20 }} >
                  <h5>
                    "What is the approximate value of this Personal Property?" <span className='asteriskIcon'>*</span>
                  </h5>
                  <SliderLayout
                    marks={marks}
                    value={personal_property_value}
                    updateField={updateField}
                    name="personal_property_value"
                    updateRadioBtnToggle={updateRadioBtnToggle}
                  />
                  <div className="sliderValue center-align silder-align">
                    {wizard.personal_property_value || "$0"}
                  </div>
                </div>)}
              </div>
            ) : null}

            <Row style={{ display: 'flex', justifyContent: 'center', marginTop: '50px' }} className='center'>
              <Col span={18} className='didyouKnowSection'>
                {/* <img src={require("./images/didyouKnow.png")} width={120} className='imgdid' /> */}
                <img src={require('./images/didYouKnowBulb.jpg')} width={40} alt='' />
                <h4>Did You Know</h4>
                <p className="textContent">“Scheduled personal property protects valuable items that are out of the ordinary and need to carry separate coverage to ensure that their full value is covered in the event of a claim.”</p>
              </Col>
            </Row>
            {/* <WizardFooter {...this.props} /> */}
          </Card>
        </div>
        <div className='stepFooter'>
          <WizardFooter {...this.props} />
        </div>
      </Fragment>
    );
  }
}

export default Step;



// WEBPACK FOOTER //
// ./src/scenes/Wizard/parts/step3_4_updated.js